define('views/modules/setting/business/payment/payment-method-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    'services/i18n',
    // views
    'views/parts/info-section',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/setting/business/payment/payment-method-form.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, Bootbox, U, i18n,
    // views
    VInfoSection,
    VChoices,
    // templates
    TPaymentMethodForm
) {

    var VPaymentMethodForm = Backbone.Epoxy.View.extend({
        template: TPaymentMethodForm,

        regions: {
            form: {
                paymentMethod: '.payment-method-input',
            }
        },

        initialize: function(opt) {
            this.options = opt = opt || {};

            var model = this.model = this.options.model;

            this.view = {
                info: new VInfoSection({
                    title: "payment:choose_payment_method",
                    content: this.template,
                }),
                form: {
                    paymentMethod: new VChoices({
                        model: model,
                        radio: true,
                        styleButton: false,
                        imageLabel: true,
                        attribute: 'paymentType',
                        labelposition: "right",
                        addClass: "btn-group",
                        addItemClass: "btn-group-horizontal",
                        choices: [
                            { label: 'assets/images/paypal_logo.png', value: 'paypal' },
                            { label: 'assets/images/creditcard_logo.png', value: 'creditcard' }
                        ]
                    })
                }
            };

            this.listenTo(model, "change:paymentType", this.onPaymentTypeChange);
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext());

            this.$el.empty().append(html);

            this.assign(this.view.info, this.$el);

            this.generateZones()
                .assign(this.view.form.paymentMethod, this.zone.form.$paymentMethod);

            this.onPaymentTypeChange(this.model);

            return this;
        },

        toggleDisplay: function(isCreditCardPayment) {
            this.$el.toggleClass('hidden', !isCreditCardPayment);
        },

        onPaymentTypeChange: function(model) {
            this.$el.find('.payment-paypal-message').toggleClass('hidden', model.isCreditCardPayment());
            this.$el.find('.payment-credit-card-message').toggleClass('hidden', !model.isCreditCardPayment());
        }
    });

    return VPaymentMethodForm;
});

